<template>
  <div class="modal-overlay">
    <button class="close-btn" @click="closeMessageModal()">✕</button>

    <div class="modal-content">

      <!-- Верх -->
      <div class="header">
        <div class="logo"></div>
        <div class="company-info">
          <strong>
            ИНДИВИДУАЛЬНЫЙ ПРЕДПРИНИМАТЕЛЬ
            НУРМУХАМЕТОВ АЙДАР НАИЛЕВИЧ
          </strong>
          <p>
            Юридический адрес организации 427283, РОССИЯ, РЕСП УДМУРТСКАЯ,
            СЕЛТИНСКИЙ Р-Н, С УТЬ СЮМСИ, УЛ МОЛОДЕЖНАЯ, Д 1
          </p>
          <p>ИНН 165051646716</p>
          <p>ОГРН/ОГРНИП 315165000014031</p>
          <p>Р/с 4080281030000020877</p>
          <p>АО «ТИНЬКОФФ БАНК»</p>
          <p>БИК 044525974</p>
        </div>
      </div>

      <!-- Текст -->
      <div class="body">
        <h2>Уважаемые руководители!</h2>

        <p>
          Мы искренне благодарны вам за то, что вы идёте с нами по этому творческому пути.
          Международное хореографическое сообщество «Танцуй, Россия» объединяет лучшие
          танцевальные коллективы, педагогов и участников со всей России и ближнего зарубежья.
        </p>

        <p>
          Хотим поздравить вас со вступлением в ряды нашего международного хореографического движения!
          Для нас большая честь приветствовать вас в числе наших резидентов.
        </p>

        <p>
          Мы рады предоставлять вам эксклюзивные бонусы, возможности для профессионального роста
          и участия в уникальных проектах сообщества.
        </p>

        <p>
          Мы искренне благодарим вас за доверие и сотрудничество.
          Желаем вам успехов, вдохновения и удачи на вашем профессиональном пути!
        </p>
      </div>

      <!-- Низ -->
      <div class="footer">
        <div class="signature">
          <p>С уважением,</p>
          <p>
            Генеральный директор Международного
            хореографического движения «Танцуй, Россия»
          </p>
        </div>

        <div class="stamp"></div>

        <strong class="name">
          Нурмухаметов Айдар Наилевич
        </strong>
      </div>

    </div>
  </div>
</template>

<script>
  import { useModalStore } from "@/stores/modals";
export default {
  setup() {
    const modalStore = useModalStore();
    return { modalStore };
  },
  methods: {
    closeMessageModal() {
      this.modalStore.closeMessageModal();
    }
  }
};
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  inset: 0;
  background: #fff;
  z-index: 1000;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0; /* убрали огромный padding-top */
  display: flex;
  justify-content: center;
  align-items: flex-start; /* контент начинается сверху */
  padding-top: 5vw; /* небольшой отступ сверху */
}

/* Кнопка закрытия */
.close-btn {
  position: fixed;
  top: 16px;
  right: 16px;
  font-size: 26px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1100;
}

/* Контент */
.modal-content {
  max-width: 900px;
  width: 90%;
  margin: 0 auto;
  padding: 5vw 5vw 5vw; /* одинаковый паддинг для всех сторон */
  box-sizing: border-box;
}

/* Верх */
.header {
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  align-items: flex-start;
}

.logo {
  width: 50px; /* фиксированный размер на мобилках */
  min-width: 50px;
  height: 50px;
  background-image: url("@/assets/Logo.png");
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0; /* чтобы не сжималось */
}

/* Компания */
.company-info {
  flex: 1;
  font-size: 1rem;
  line-height: 1.4;
}

/* Низ */
.footer {
  margin-top: 48px;
  display: flex;
  gap: 24px;
  align-items: center;
  flex-wrap: wrap;
}

.stamp {
  width: 20vw; /* фиксированный размер на мобилках */
  height: 20vw;
  background-image: url("@/assets/images/Stamp.png");
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0; /* чтобы не сжималось */
}

/* 📱 Телефон */
@media (max-width: 768px) {
  .header {
    flex-direction: column;
    align-items: flex-start;
  }

  .logo-placeholder {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
  }

  .modal-content {
    padding: 10vw 5vw 5vw; /* убрали огромный 140vw */
  }

  .footer {
    flex-direction: column;
    align-items: flex-start;
  }

  .company-info {
    font-size: 4vw;
    line-height: 1.5;
  }
  .stamp {
  width: 60vw; /* фиксированный размер на мобилках */
  height: 60vw;
}
}

</style>
